import companyPlanningRecordLettersSlice from './companyPlanningRecordLettersSlice'
export default companyPlanningRecordLettersSlice.reducer
